import { Mic } from 'lucide-react';

export const VoiceButton = ({ isRecording, onClick }) => (
  <button type="button" onClick={onClick} title="Voice Typing" className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors ${isRecording ? 'bg-red-100 dark:bg-red-900/30 text-red-500 animate-pulse' : 'text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-600'}`}>
    <Mic size={17} />
  </button>
);
